class CustomTabs extends HTMLElement {
  constructor() {
    super();

    const buttons = this.querySelectorAll('.tab-button');
    buttons.forEach(button => {
      button.addEventListener('click', () => this.switchTab(button));
    });
  }

  switchTab(selectedButton) {
    this.querySelectorAll('.tab-button').forEach(btn => {
      btn.classList.remove('active');
    });
    this.querySelectorAll('.tab-content').forEach(content => {
      content.classList.remove('active');
    });

    selectedButton.classList.add('active');
    const tabId = selectedButton.getAttribute('data-tab');
    this.querySelector(`.tab-content[data-tab="${tabId}"]`).classList.add('active');
  }
}
customElements.define('custom-tabs', CustomTabs);

class ModalPopup extends HTMLElement {
  constructor() {
    super();
    this._modalOverlay = null;
    this._modalBox = null;
    this._boundTriggerHandler = this._triggerHandler.bind(this);
    this._boundOverlayClick = this._overlayClick.bind(this);
    this._boundBoxClick = this._boxClick.bind(this);
    this._observer = new MutationObserver(() => this._updateTriggers(true));
    this._contentHTML = this.innerHTML; // Save initial content
  }

  open() {
    if (!this._modalOverlay) this._createModal();
    // Always update content in case it changed
    this._modalBox.innerHTML = this._contentHTML;
    this._modalBox.style.display = 'block';
    this._modalOverlay.style.display = 'block';
  }
  close() {
    if (this._modalOverlay) this._modalOverlay.style.display = 'none';
    if (this._modalBox) this._modalBox.style.display = 'none';
  }

  _createModal() {
    // Create overlay
    this._modalOverlay = document.createElement('div');
    this._modalOverlay.className = 'modal-overlay';
    this._modalOverlay.style.display = 'none';
    this._modalOverlay.addEventListener('click', this._boundOverlayClick);

    // Create modal box
    this._modalBox = document.createElement('div');
    this._modalBox.className = 'modal-box';
    this._modalBox.style.display = 'none';
    this._modalBox.addEventListener('click', this._boundBoxClick);

    // Append to body
    document.body.appendChild(this._modalOverlay);
    document.body.appendChild(this._modalBox);
  }

  _overlayClick() {
    this.close();
  }

  _boxClick(e) {
    if (e.target.closest('[data-modal-close]')) {
      this.close();
    }
  }

  _triggerHandler() {
    this.open();
  }

  _updateTriggers(add = true) {
    // Find all triggers that point to this modal
    const selector = `[data-modal-trigger="#${this.id}"]`;
    this._triggers = Array.from(document.querySelectorAll(selector));
    this._triggers.forEach(trigger => {
      if (add) {
        trigger.addEventListener('click', this._boundTriggerHandler);
      } else {
        trigger.removeEventListener('click', this._boundTriggerHandler);
      }
    });
  }

  connectedCallback() {
    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '-1');
    this._contentHTML = this.innerHTML; // Save content for modal
    this._updateTriggers(true);
    this._observer.observe(this, { childList: true, subtree: true });
  }
  disconnectedCallback() {
    this._updateTriggers(false);
    this._observer.disconnect();
    if (this._modalOverlay) this._modalOverlay.remove();
    if (this._modalBox) this._modalBox.remove();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'id' && oldValue !== newValue) {
      this._updateTriggers(false); // Remove old triggers
      this._updateTriggers(true);  // Add new triggers
    }
  }
  static get observedAttributes() {
    return ['id'];
  }
}
customElements.define('modal-popup', ModalPopup);